// Usuario demo — reemplazable, sin secretos (regla §0.1)
export const demoUser = {
  id: "u-demo-1",
  name: "David V.",
  initials: "DV",
  email: "david@aviando.app",
  plan: "pro",
};

export const demoTenant = {
  id: "t-demo-1",
  name: "Espacio de David",
};

export const DEMO_SESSION_TOKEN = "demo-session-token";
